<template>
	<div class="carousel-container" @touchstart="handleTouchStart" @touchend="handleTouchEnd" ref="container">
		<div class="carousel-wrapper" :style="{ transform: 'translateX(' + offset + 'px)' }">
			<div class="carousel-item" ref="carouselItem" v-for="(item, index) in items" :key="index">
				<div class="carousel-img"
					:style="{ width: itemWidth + 'px',backgroundImage: 'url(' + item.fileList[0].filePath + ')' }"></div>
				<div class="carousel-text" :style="{color: item.titleTextColor,fontSize:item.titleTextSize+'px',bottom:item.titleTextBottom+'px'}" :class="{test:currentIndex === index}">{{ item.titleName }}</div>
			</div>
		</div>
		<div class="parentNav">
			<div class="nav" v-for="(item, index) in items" :key="index" :class="{pitchOn:currentIndex === index}">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Carousel",
		props: {
		    items: Array
		  },
		data() {
			return {
				offset: 0,
				currentIndex: 0,
				itemWidth: 0
			};
		},
		mounted() {
			this.itemWidth = this.$refs.container.clientWidth;
			window.addEventListener("resize", this.handleResize);
			this.autoPlay();
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.handleResize);
			clearInterval(this.timer);
		},
		methods: {
			autoPlay() {
				this.timer = setInterval(() => {
					this.next();
				}, 5000);
			},
			prev() {
				if (this.currentIndex === 0) {
					this.currentIndex = this.items.length - 1;
					this.offset = -this.currentIndex * this.itemWidth;
				} else {
					this.currentIndex--;
					this.offset += this.itemWidth;
				}

			},
			next() {
				if (this.currentIndex === this.items.length - 1) {
					this.currentIndex = 0;
					this.offset = 0;
				} else {
					this.currentIndex++;
					this.offset -= this.itemWidth;
				}
			},
			handleResize() {
				this.itemWidth = this.$refs.container.clientWidth;
				this.offset = -this.currentIndex * this.itemWidth;
			},
			handleTouchStart(e) {
				this.touchStartX = e.touches[0].clientX;
			},
			handleTouchEnd(e) {
				clearInterval(this.timer);
				this.autoPlay();
				this.touchEndX = e.changedTouches[0].clientX;
				if (this.touchEndX - this.touchStartX > 50) {
					this.prev();
				} else if (this.touchEndX - this.touchStartX < -50) {
					this.next();
				}
				this.touchStartX = 0;
				this.touchEndX = 0;
			}
		}
	};
</script>

<style scoped>
	@keyframes example {
		0% {
			transform: translateX(100%);
			opacity: 0;
		}

		100% {
			transform: translateX(0%);
			opacity: 1;
		}
	}

	.carousel-container {
		position: relative;
		overflow: hidden;
		width: 100%;
		height: 620px;
		text-align: center;
	}

	.carousel-wrapper {
		display: flex;
		transition: transform 0.5s ease-in-out;
		width: 100%;
		height: 100%;
	}

	.carousel-item {
		position: relative;
		width: 100%;
	}

	.carousel-img {
		height: 100%;
		background-size: cover;
		background-position: center;
		transition: opacity 0.5s ease-in-out;
	}

	.carousel-text {
		position: absolute;
		bottom: 50px;
		left: 0;
		right: 0;
		margin: 0 auto;
		padding: 20px 20px;
		color: #fff;
		font-size: 24px;
		text-align: center;
		font-weight: 600;
	}

	.carouselTextActive {
		color: black;
	}
	.test {
		animation: example 0.5s ease-out 0.5s backwards
	}

	.carousel-prev,
	.carousel-next {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.5);
		color: #fff;
		font-size: 20px;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		transition: opacity 0.3s ease-in-out;
	}

	.carousel-prev:hover,
	.carousel-next:hover {
		opacity: 0.8;
	}

	.carousel-prev {
		left: 20px;
	}

	.carousel-next {
		right: 20px;
	}

	.parentNav {
		position: absolute;
		bottom: 5px;
		right: 20px;
		display: flex;
	}

	.nav {
		background-color: #840000;
		width: 8px;
		height: 8px;
		margin: 0px 5px;
		opacity: 0.85;
	}

	.pitchOn {
		width: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/assembly/carousels.vue